import { useDispatch } from 'react-redux';
import { handleError } from '../store/features/alertSlice';
import { useCallback, useMemo } from 'react';
export function useErrorHandling(callback) {
  let onFinally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let overrideHttpStatusErrorHandlers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  const dispatch = useDispatch();
  const onFinallyCallback = useMemo(() => onFinally || (() => {}), [onFinally]);
  const onErrorCallback = useMemo(() => onError || (() => {}), [onError]);
  const errorHandler = useCallback(async function () {
    try {
      return await callback(...arguments);
    } catch (error) {
      if (error.http_status && overrideHttpStatusErrorHandlers && overrideHttpStatusErrorHandlers[error.http_status]) {
        overrideHttpStatusErrorHandlers[error.http_status](error);
        return;
      }
      dispatch(handleError(error));
      onErrorCallback(error);
    } finally {
      onFinallyCallback();
    }
  }, [callback, dispatch, onErrorCallback, onFinallyCallback, overrideHttpStatusErrorHandlers]);
  return errorHandler;
}